const checkTime = () => {
    let now = new Date().getTime();
    let setupTime = localStorage.getItem("lastTimeStamp");

    if( now-setupTime > 60*60*1000) {
      localStorage.clear();
      window.location.href = "/login"
    } else {
      localStorage.setItem('lastTimeStamp', now);
    }

}
  
export default checkTime;
  